import { DateTime } from 'luxon'
import React, { useState } from 'react'
import GetAppIcon from '@mui/icons-material/GetApp';
import CloseIcon from '@mui/icons-material/Close';
import pdf from '../../assets/img/formula_icon.svg';
import pdfRai from '../../assets/img/canone_icon.svg'
import PaymentIcon from '@mui/icons-material/Payment';
import { useSelector } from 'react-redux';
import axios from 'axios';
import md5 from 'md5';
import { Collapse, IconButton, Button } from '@mui/material';
import { Alert } from '@mui/material';


function Item({item, render}) {
    const saldoAttuale = useSelector((user) => user.user.currentBalanceEnrica);
    const token = useSelector((user) => user.user?.datiPagamento?.token);
    const customerId = useSelector((user) => user.user.info.customer_id);
    const tknPvt = md5(customerId + 'oYmAIdtki%lu')
    const [collapse, setCollapse] = useState(false)


    const changeReason = (r) => {
        switch (r) {
            case 'rai':
                return 'Canone RAI';
            case 'contratto':
                return 'Contratto';
            default:
                return 'Fattura';
        }
    }

    const switchImage = () => {
        const tag = item.tag;
        switch (tag) {
            case 'rai':
                return <img src={pdfRai} alt="Fattura RAI" />
            case 'contratto':
                return <img src="fake_url" alt="Contratto" />
            default :
                return <img src={pdf} alt="Fattura" />
        }


    }

    const handleItem = (item) => {
        setCollapse(!collapse)
    }
    const payNow = async (item) => {
        console.log(item)
        const saldo = saldoAttuale;
        const urlMin = `https://my.revoluce.it/area_utente/gestione/api/payments/payOnereByCredit.php?tkn_pvt=${tknPvt}&customer_id=${customerId}&entry_id=${item.entry_id}&importo=${item.entry_amount}`;
        const urlMag = `https://my.revoluce.it/area_utente/gestione/api/payments/payOnere.php?importo=${item.entry_amount}&customer_id=${customerId}&token=${token}&entry_id=${item.entry_id}&tkn_pvt=${tknPvt}`
        if(saldo >= item.entry_amount) {
            await axios.get(urlMin).then(({ data }) => {
                if(data.success === false) {
                    alert('Il pagamento della fattura è già in corso.')
                    render(true)

                } else {
                    alert('Pagamento eseguito correttamente')
                    render(true)
                }
            })
            render(true)
        } else if(saldo < item.entry_amount){
            await axios.get(urlMag).then(({ data }) => {
                if(data.success === false) {
                    alert('Il pagamento della fattura è già in corso.')
                    render(true)
                } else {
                    alert('Pagamento eseguito correttamente')
                    render(true)
                }
            })
        }
    
    }
    return (
        <div className="item">
            <div className="body">
                <div className="img">
                    {switchImage()}
                </div>
                <div className="info">
                    <div className="info_date">
                        {item.tag === 'contratto' ? (
                            <p>Attivo dal {DateTime.fromISO(item.entry_date).toFormat('D')}</p>
                        ) : (
                            <p>{item.numero_fattura} del {DateTime.fromISO(item.entry_date).toFormat('D')}</p>
                        )}
                        
                    </div>
                    <div className="top_info">
                        <p className="reason">{changeReason(item.tag)}</p>
                        {item.tag === 'contratto' ? null : (
                            <p className='amount'>{parseFloat(item.entry_amount).toFixed(2).replace(/\./g, ',')} €</p>
                        )}

                    </div>
                    <div className="bottom_info">
                        <a className="note" href={item.url}>
                            <GetAppIcon />
                            Scarica
                        </a>
                        {item.data_pagamento !== null ? null : item.data_scaenza > DateTime.now().toISO() ? (
                            <div className="payNow">
                                <PaymentIcon/>
                            </div>
                        ) : item.tag !== 'contratto' ? (
                            <div className="payNow" onClick={() => handleItem(item)}>
                                <p>Paga</p>
                            </div>
                        ) : null}
                        {item.data_pagamento !== null ? (
                            <div className="expiry green">
                                <p>Pagata il {DateTime.fromISO(item.data_scadenza).toFormat('D')}</p>
                            </div>  
                        ) : item.data_scadenza > DateTime.now().toISO() ? (
                            <div className="expiry">
                                <p>Scade il {DateTime.fromISO(item.data_scadenza).toFormat('D')}</p>
                            </div>
                        ) : (
                            <div className="expiry red">
                                <p>Scaduto il {DateTime.fromISO(item.data_scadenza).toFormat('D')}</p>
                            </div> 
                        )}
                       
                    </div>
                </div>
            </div>  
            <Collapse in={collapse}>
                <Alert>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                        <p>Procedere con il pagamento?</p>
                        <CloseIcon onClick={() => setCollapse(!collapse)}/>
                    </div>
                    <Button onClick={()=> payNow(item)} style={{backgroundColor: '#a61470', color: '#fff', height: '30px'}}> Procedi </Button>
                </Alert>
            </Collapse>
        </div>
    );
}

export default Item
